










































import { defineComponent, reactive } from '@vue/composition-api'

import { UserRole } from '@/types/user'
import { RecommendState, UserState } from '@/types/store'

import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { RecommendsTable } from '@/components/organisms/recommends'

export default defineComponent({
  name: 'AdminRecommends',
  components: { Layout, RecommendsTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      recommends: useVuex<RecommendState['recommends']>(
        context,
        () => store.getters['recommend/recommends'],
      ),
      isRecommendsLoading: useVuex<RecommendState['isRecommendsLoading']>(
        context,
        () => store.getters['recommend/isRecommendsLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      query: '',
      categoryId: -1,
    })

    const search = async () => {
      if (state.categoryId > -1) {
        try {
          store.dispatch('recommend/getRecommends', {
            query: state.query,
            categoryId: state.categoryId,
          })
        } catch (_) {
          alert('タイムアウトしました。検索条件を変更して再度お試しください。')
        }
        return
      }
      if (state.query.length > 0) {
        try {
          await store.dispatch('recommend/getRecommends', {
            query: state.query,
            categoryId: state.categoryId,
          })
        } catch (_) {
          store.dispatch('recommend/reset')
          alert('タイムアウトしました。検索条件を変更して再度お試しください。')
        }
        return
      }
      store.dispatch('recommend/reset')
    }

    const categories = [
      {
        text: '',
        value: -1,
      },
      {
        text: '生鮮・惣菜',
        value: 1,
      },
      {
        text: '飲食チェーン',
        value: 2,
      },
      {
        text: 'その他商品',
        value: 3,
      },
      {
        text: 'PBその他商品',
        value: 10,
      },
    ]

    return { state, search, UserRole, categories }
  },
})
